var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "placeholder_1_",
    "data-name": "placeholder (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.359,
    height: 19,
    viewBox: "0 0 13.359 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M82.68,0A6.681,6.681,0,0,0,77,10.192l5.3,8.545a.557.557,0,0,0,.473.263h0a.557.557,0,0,0,.473-.271L88.417,10.1A6.681,6.681,0,0,0,82.68,0Zm4.782,9.53-4.7,7.844L77.943,9.606a5.57,5.57,0,1,1,9.519-.075Z",
    transform: "translate(-76)",
    fill: "rgba(248,225,247,0.5)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(3.34 3.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M169.34,90a3.34,3.34,0,1,0,3.34,3.34A3.344,3.344,0,0,0,169.34,90Zm0,5.574a2.234,2.234,0,1,1,2.23-2.234A2.236,2.236,0,0,1,169.34,95.574Z",
    transform: "translate(-166 -90)",
    fill: "rgba(248,225,247,0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/Pin Icon.16c15041ceda53fc3c4e9412eba735da.svg";
export { ForwardRef as ReactComponent };